import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { orderService } from '../services/orderService';
import Loading from '../components/common/Loading';
import './KhaltiCallback.css';

const EsewaCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // verifying | success | failed | canceled
  const [message, setMessage] = useState('Verifying your payment...');
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const data = searchParams.get('data');
    const failureFlag = searchParams.get('status');

    if (failureFlag === 'failure') {
      setStatus('canceled');
      setMessage(
        'Payment was cancelled or failed at eSewa. Your order is still saved — you can retry payment later.'
      );
      return;
    }

    if (!data) {
      setStatus('failed');
      setMessage('Invalid payment callback. No payment data received.');
      return;
    }

    const verifyPayment = async () => {
      try {
        const result = await orderService.verifyEsewaPayment(data);
        if (result.success) {
          setStatus('success');
          setMessage('Payment successful! Your order has been confirmed.');
          setOrder(result.data?.order);
        } else {
          const esewaStatus = result.data?.esewa_status;
          if (esewaStatus === 'CANCELED') {
            setStatus('canceled');
            setMessage('You cancelled the payment. Your order is still saved.');
          } else if (
            esewaStatus === 'PENDING' ||
            esewaStatus === 'AMBIGUOUS'
          ) {
            setStatus('failed');
            setMessage(
              'Payment is still being processed by eSewa. We will update your order once confirmation arrives.'
            );
          } else {
            setStatus('failed');
            setMessage(result.message || 'Payment verification failed.');
          }
        }
      } catch (error) {
        setStatus('failed');
        setMessage(
          error.message ||
            'Failed to verify payment. Please contact support if you were charged.'
        );
      }
    };

    verifyPayment();
  }, [searchParams]);

  const handleGoToOrders = () => navigate('/profile?orderSuccess=true');
  const handleGoHome = () => navigate('/');

  if (status === 'verifying') {
    return (
      <div className="khalti-callback-page">
        <div className="khalti-callback-card">
          <div className="khalti-loading">
            <Loading />
            <p>{message}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="khalti-callback-page">
      <div className="khalti-callback-card">
        <div className={`khalti-status-icon ${status}`}>
          {status === 'success' && '✓'}
          {status === 'failed' && '✕'}
          {status === 'canceled' && '↩'}
        </div>

        <h2 className={`khalti-status-title ${status}`}>
          {status === 'success' && 'Payment Successful'}
          {status === 'failed' && 'Payment Failed'}
          {status === 'canceled' && 'Payment Cancelled'}
        </h2>

        <p className="khalti-status-message">{message}</p>

        {order && (
          <div className="khalti-order-info">
            <p>
              Order: <strong>#{order.order_number}</strong>
            </p>
            <p>
              Total:{' '}
              <strong>Rs. {parseFloat(order.total).toLocaleString()}</strong>
            </p>
          </div>
        )}

        <div className="khalti-callback-actions">
          {status === 'success' && (
            <button className="btn-primary" onClick={handleGoToOrders}>
              View My Orders
            </button>
          )}
          {(status === 'failed' || status === 'canceled') && (
            <>
              <button className="btn-primary" onClick={handleGoToOrders}>
                View My Orders
              </button>
              <button className="btn-secondary" onClick={handleGoHome}>
                Go Home
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default EsewaCallback;
